import { Notification } from '@zipari/design-system';

export const NOTIFICATIONS: Notification[] = [
  {
    id: '1',
    subtype: 'document',
    title: 'Complete Your Health Risk Assessment Survey',
    body: "Take a moment to complete your <a href='http://example.com'>Health Risk Assessment Survey</a>!",
    created_at: '2020-05-03T16:57:20.871884',
    is_read: false,
    is_deletable: false,
  },
  {
    id: '2',
    created_at: '2020-04-16T09:24:00',
    subtype: 'enrollment',
    is_read: false,
    is_deletable: true,
    title: 'Complete Your Health Risk Assessment (HRA) Survey',
    body: 'Take a moment to complete your Health Risk Assessment Survey so we can better serve your needs. <a class="t-bold t-link">Click here to get started!</a>',
  },
  {
    id: '3',
    created_at: '2020-03-16T09:24:00',
    subtype: 'general',
    is_read: true,
    is_deletable: true,
    title: "It's Time to Kick the Habit!",
    body: 'You ever see that commercial with the lady who has to talk through a hole in her neck? <a class="t-bold t-link">Don\'t be that lady.</a>',
  },
  {
    id: '4',
    created_at: '2020-02-16T09:24:00',
    subtype: 'enrollment',
    is_read: true,
    is_deletable: true,
    title: 'Formatting for read notification that hasn’t been dismissed.',
    body: "I'm baby sustainable keytar normcore blue bottle austin typewriter palo santo chicharrones try-hard letterpress chartreuse snackwave jianbing.Hoodie cornhole hexagon, disrupt salvia wayfarers master cleanse freegan cronut mlkshk YOLO fashion axe craft beer microdosing.",
  },
  {
    id: '5',
    created_at: '2020-01-16T09:24:00',
    subtype: 'enrollment',
    is_read: true,
    is_deletable: true,
    title: 'Formatting for read notification that hasn’t been dismissed.',
    body: "I'm baby sustainable keytar normcore blue bottle austin typewriter palo santo chicharrones try-hard letterpress chartreuse snackwave jianbing.Hoodie cornhole hexagon, disrupt salvia wayfarers master cleanse freegan cronut mlkshk YOLO fashion axe craft beer microdosing.",
  },
  {
    id: '6',
    created_at: '2019-12-16T09:24:00',
    subtype: 'payment',
    is_read: true,
    is_deletable: true,
    title: 'Formatting for read notification that hasn’t been dismissed.',
    body: "I'm baby sustainable keytar normcore blue bottle austin typewriter palo santo chicharrones try-hard letterpress chartreuse snackwave jianbing.Hoodie cornhole hexagon, disrupt salvia wayfarers master cleanse freegan cronut mlkshk YOLO fashion axe craft beer microdosing.",
  },
  {
    id: '7',
    created_at: '2019-11-16T09:24:00',
    subtype: 'payment',
    is_read: true,
    is_deletable: true,
    title: 'Formatting for read notification that hasn’t been dismissed.',
    body: "I'm baby sustainable keytar normcore blue bottle austin typewriter palo santo chicharrones try-hard letterpress chartreuse snackwave jianbing.Hoodie cornhole hexagon, disrupt salvia wayfarers master cleanse freegan cronut mlkshk YOLO fashion axe craft beer microdosing.",
  },
  {
    id: '8',
    created_at: '2019-10-16T09:24:00',
    subtype: 'benefits',
    is_read: true,
    is_deletable: true,
    title: 'Formatting for read notification that hasn’t been dismissed.',
    body: "I'm baby sustainable keytar normcore blue bottle austin typewriter palo santo chicharrones try-hard letterpress chartreuse snackwave jianbing.Hoodie cornhole hexagon, disrupt salvia wayfarers master cleanse freegan cronut mlkshk YOLO fashion axe craft beer microdosing.",
  },
  {
    id: '9',
    created_at: '2019-09-16T09:24:00',
    subtype: 'general',
    is_read: true,
    is_deletable: true,
    title: 'Formatting for read notification that hasn’t been dismissed.',
    body: "I'm baby sustainable keytar normcore blue bottle austin typewriter palo santo chicharrones try-hard letterpress chartreuse snackwave jianbing.Hoodie cornhole hexagon, disrupt salvia wayfarers master cleanse freegan cronut mlkshk YOLO fashion axe craft beer microdosing.",
  },
  {
    id: '10',
    created_at: '2019-08-16T09:24:00',
    subtype: 'payment',
    is_read: true,
    is_deletable: true,
    title: 'Formatting for read notification that hasn’t been dismissed.',
    body: "I'm baby sustainable keytar normcore blue bottle austin typewriter palo santo chicharrones try-hard letterpress chartreuse snackwave jianbing.Hoodie cornhole hexagon, disrupt salvia wayfarers master cleanse freegan cronut mlkshk YOLO fashion axe craft beer microdosing.",
  },
  {
    id: '11',
    created_at: '2019-07-16T09:24:00',
    subtype: 'payment',
    is_read: true,
    is_deletable: true,
    title: 'Formatting for read notification that hasn’t been dismissed.',
    body: "I'm baby sustainable keytar normcore blue bottle austin typewriter palo santo chicharrones try-hard letterpress chartreuse snackwave jianbing.Hoodie cornhole hexagon, disrupt salvia wayfarers master cleanse freegan cronut mlkshk YOLO fashion axe craft beer microdosing.",
  },
].map((notification) => new Notification(notification));
